export default "__VITE_ASSET__EyqRDdIf__"